import React, { useEffect, useState } from "react";
import { ReactComponent as TickIcon } from "../../assets/tick.svg";
import VisualDetails from "./components/visual-details";
import VenueAddress from "./components/VenueAddress";
import VenueDimension from "./components/VenueDimension";
import OtherDetails from "./components/OtherDetails";
import VenueDetails from "./components/VenueDetails";
import SeatingsArrangement from "./components/seating-arrangment/index";
import { Step, StepButton, StepIndicator, Stepper } from "@mui/joy";
import { useLocation, useNavigate } from "react-router-dom";
import httpServices from "../../services/httpServices";
import { LeftArrowIcon } from "./venue details/Icons";

const steps = [
  "Venue Details",
  "Images",
  "Address",
  "Dimension",
  "Seating",
  "Other details",
];
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

function CreateVenue() {
  const query = useQuery();
  const id = query.get("id");
  const stepDone = query.get("step");
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(+stepDone || 0);
  const [venueId, setVenueId] = useState(id);

  const [venueData, setVenueData] = useState(null);

  const getVenueDetails = async () => {
    const { response } = await httpServices.get(`/venue/${venueId}`, {
      skip: !venueId,
    });
    if (response?.status === 200) {
      // console.log("Response from getVenueDetails", response.data);
      setVenueData(response?.data?.data);
    }
  };

  useEffect(() => {
    getVenueDetails();
  }, [activeStep]);

  const renderComponent = () => {
    switch (activeStep) {
      case 0:
        return (
          <VenueDetails
            setActiveStep={setActiveStep}
            setVenueId={setVenueId}
            venueData={venueData}
          />
        );
      case 1:
        return (
          <VisualDetails
            setActiveStep={setActiveStep}
            venueId={venueId}
            venueData={venueData}
          />
        );
      case 2:
        return (
          <VenueAddress
            setActiveStep={setActiveStep}
            venueId={venueId}
            venueData={venueData}
          />
        );
      case 3:
        return (
          <VenueDimension
            setActiveStep={setActiveStep}
            venueId={venueId}
            venueData={venueData}
          />
        );
      case 4:
        return (
          <SeatingsArrangement
            setActiveStep={setActiveStep}
            venueId={venueId}
            venueData={venueData}
          />
        );
      case 5:
        return (
          <OtherDetails
            setActiveStep={setActiveStep}
            venueId={venueId}
            venueData={venueData}
          />
        );
      case 6:
        navigate("/venue");
        return null;

      default:
        return (
          <SeatingsArrangement
            setActiveStep={setActiveStep}
            venueId={venueId}
          />
        );
    }
  };
  const handleBack = () => {
    if (activeStep === 0) {
      navigate("/venue");
    } else {
      setActiveStep(activeStep - 1);
    }
  };
  return (
    <>
      <>
        {activeStep !== 6 && (
          <div className="w-full bg-white py-4 px-8 justify-center flex">
            <div className="cursor-pointer" onClick={handleBack}>
              <LeftArrowIcon />
            </div>
            <Stepper sx={{ width: "100%", "--StepIndicator-size": "28px" }}>
              {steps.map((step, index) => (
                <Step
                  orientation={"vertical"}
                  key={step}
                  indicator={
                    <StepIndicator
                      variant={activeStep <= index ? "soft" : "solid"}
                      color={activeStep < index ? "neutral" : "primary"}
                      sx={{
                        backgroundImage:
                          activeStep < index
                            ? "transparent"
                            : "linear-gradient(180deg, #4DB1E1 0%, #2E3E8D 100%)",
                        bgcolor: activeStep < index ? "transparent" : "white",
                        border:
                          activeStep < index ? "1px solid #A4A8B5" : "none",
                        color:
                          activeStep < index ? "rgba(0, 0, 0, 0.38)" : "white",
                        fontSize: "12px",
                      }}
                    >
                      {activeStep <= index ? "0" + (index + 1) : <TickIcon />}
                    </StepIndicator>
                  }
                  sx={{
                    "&::after": {
                      height: "3px !important",
                      backgroundSize: "20px 3px",
                      backgroundRepeat: "repeat-x",
                      backgroundColor: "transparent",
                      backgroundImage:
                        activeStep <= index
                          ? "linear-gradient(to right, #A4A8B5 40%, rgba(255, 255, 255, 0) 20%)"
                          : "linear-gradient(180deg, #4DB1E1 0%, #2E3E8D 100%)",
                    },
                  }}
                >
                  <StepButton onClick={() => setActiveStep(index)}>
                    {step}
                  </StepButton>
                </Step>
              ))}
            </Stepper>
          </div>
        )}
        <div>{renderComponent()}</div>
      </>
    </>
  );
}

export default CreateVenue;
